<template>
    <div class="no_container">
         <div class="title">
              <span>请填写不通过原因</span>
              <span>*</span>
         </div>
         <div class="content">
             <textarea placeholder="请输入内容..." class="txt" v-model="reason" :maxLength="total"></textarea>
            <span class="total">{{changeLength}}/字</span>
         </div>
         <div class="file-contain">
            <div class="file-title"><span>上传附件</span></div>
            <div class="img-contain">
                <div class="posting-uploader-item" v-for="(item,nn) in postData" :key="nn">
                    <img :src="item.content" alt="图片" class="imgPreview">
                    <img src="../../assets/guideSystem/delete.png" class="delte" @click="delImg(nn)">
                    <!-- <van-icon name="close" @click="delImg(nn)" class="delte"/> -->
                </div>
                <van-uploader :after-read="onRead" multiple="true" :accept="'image/*'">
                    <!-- <img src="../../assets/guideSystem/ic_upload.png" alt="等待传图" class="imgPreview"> -->
                </van-uploader>
            </div>
        </div>
        <div class="btn" :class="{'active':change}" @click="confirm">提交</div>
    </div>
</template>
<script>
    import api from '../../service/modules/guide'
    const HTTPS = 'https://'
    export default {
        data () {
            return {
                postData: [], // 图片显示临时存储
                tempFile: [],
                uploadTemp: [],
                reason: '',
                back: this.$route.query.back || '',
                total: 200
            }
        },
        watch: {

        },
        computed: {
            change () {
                if (this.reason.trim().length > 0) {
                    return true;
                } else {
                    return false;
                }
            },
            changeLength () {
                return (this.total - parseInt(this.reason.trim().length))
            }

        },
        mounted () {
            this.getSession()
        },
        created () {

        },
        methods: {
            // change(){
            //     return false
            // },
            onRead (file) { // 上传图片到图片服务器
                this.tempFile = []
                if (Array.isArray(file)) {
                    // 多图
                    for (let index = 0; index < file.length; index++) {
                        this.postData.push(file[index])
                        this.tempFile.push(file[index])
                    }
                } else {
                    // 单图
                    this.postData.push(file)
                    this.tempFile.push(file)
                }
                this.uploadFile()
            },
            getSession () {
                api.getCosSession().then(res => {
                    if (res.ret === 0) {
                        this.cosArg = res.data
                        this.cos = new COS({
                            getAuthorization: function (options, callback) {
                                callback({
                                    TmpSecretId: res.data.credentials && res.data.credentials.tmpSecretId,
                                    TmpSecretKey: res.data.credentials && res.data.credentials.tmpSecretKey,
                                    XCosSecurityToken: res.data.credentials && res.data.credentials.sessionToken,
                                    ExpiredTime: res.data.expiredTime
                                });
                            }
                        })
                    }
                });
            },
            uploadFile () {
                let cosKey = ''
                console.log('this.tempFile:', this.tempFile)
                for (let i = 0; i < this.tempFile.length; i++) {
                    cosKey = `${this.cosArg.keyPrefix}/${new Date().getTime()}/${this.tempFile[i].file.name}`
                    this.cos.putObject({
                        Bucket: this.cosArg.bucket,
                        Region: this.cosArg.region,
                        Key: cosKey,
                        Body: this.tempFile[i].file,
                        onHashProgress: function (progressData) {
                            console.log('校验中', JSON.stringify(progressData));
                        },
                        onProgress: function (progressData) {
                            console.log('上传中', JSON.stringify(progressData));
                        }
                    }, (err, res) => {
                        console.log(err, res);
                        if (!err) {
                            this.uploadTemp.push(HTTPS + res.Location)
                            console.log('this.uploadTemp:', this.uploadTemp)
                        }
                    })
                }
            },
            delImg (index) {
                // 删除指定下标的图片对象
                if (isNaN(index) || index >= this.postData.length) {
                    return false
                }
                let tmp = []
                let upTmp = []
                for (let i = 0, len = this.postData.length; i < len; i++) {
                    if (this.postData[i] !== this.postData[index]) {
                        tmp.push(this.postData[i])
                        upTmp.push(this.uploadTemp[i])
                    }
                }
                this.postData = tmp
                this.uploadTemp = upTmp
                console.log('this.uploadTemp:', this.uploadTemp)
            },
            confirm () { // 提交
                if (this.reason.trim().length == 0) {
                    this.$Toast('请填写不通过原因')
                }
                // else if (this.uploadTemp.length == 0) {
                //     this.$Toast('附件不能为空')
                // }
                else { // 不通过接口
                    api.auditNoGuide({ id: this.$route.query.id, returnReason: this.reason, enclosure: this.uploadTemp.join(',')}).then(res => {
                        if (res.ret === 0) {
                            this.$Toast.loading({
                                message: '提交成功',
                                icon: 'passed',
                                forbidClick: true
                            });
                            if (!this.back) {
                                setTimeout(() => {
                                    this.$router.go(-2);
                                }, 1000);
                            }else{
                                yyn.invokeJSB('closeWindow')
                            }
                        }
                    })
                }
            }
        }
        
    }
</script>
<style scoped lang="less">
.no_container{
    width:100%;
    height:100%;
    padding:0 12px;
    .title{
        width:100%;
        padding:24px 0;
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        span:nth-child(1){
            font-size:14px;
            color:#999;
        }
        span:nth-child(2){
            font-size:14px;
            color:red;
        }
    }
    .content{
        width:100%;
        height:180px;
        .txt{
            width:100%;
            height:100%;
            border: 0;
            outline:none;
            resize: none;
            background-color: #F9F9F9;
            padding:16px;
            font-size: 14px;
            box-sizing: border-box;
        }
        .total{
                position:absolute;
                right: 25px;
                top: 210px;
                font-size:14px;
                color:#999;
            }
    }
    .file-contain{
        display: flex;
        flex-direction: column;
        margin-top:16px;
        .file-title{
            // font-size:14px;
            // font-family:PingFangSC-Regular,PingFang SC;
            // font-weight:400;
            // color:rgba(51,51,51,1);
            // line-height:14px;
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            span:nth-child(1){
                font-size:14px;
                color:#999;
            }
            span:nth-child(2){
                font-size:14px;
                color:red;
            }
        }
        .img-contain{
            display: flex;
            flex-wrap: wrap;
            margin-top: 13px;
            .posting-uploader-item{
                width: 77px;
                height: 77px;
                position: relative;
                margin-right: 13px;
                margin-bottom: 13px;
                .imgPreview{
                    width: 100%;
                    height: 100%;
                }
                .delte{
                    width: 14px;
                    height: 14px;
                    position: absolute;
                    top: -7px;
                    right: -7px;
                    z-index: 10;
                }
            }
            .van-uploader{
                position: relative;
                top: 0!important;
            }
            .imgPreview{
                width: 77px;
                height: 77px;
            }
        }
    }
    .btn{
        width:100%;
        height:50px;
        text-align: center;
        line-height: 50px;
        color:#fff;
        background:rgba(54, 179, 116, .3);
        margin-top:25px;
        font-size:16px;
    }
    .active{
        background:rgb(54, 179, 116);
    }
}
</style>
